module.exports = __webpack_public_path__ + "img/Picture12.560c3091.png";